document.addEventListener('DOMContentLoaded', function() {
    // Variables
    const header = document.querySelector('.site-header');
    const mobileMenuToggle = document.querySelector('.mobile-menu-toggle');
    const mainNavigation = document.querySelector('.main-navigation');
    let lastScroll = 0;

    // Gestion du menu mobile
    if (mobileMenuToggle && mainNavigation) {
        mobileMenuToggle.addEventListener('click', function() {
            this.classList.toggle('active');
            mainNavigation.classList.toggle('active');
            document.body.classList.toggle('menu-open');
        });

        // Fermer le menu mobile lors du clic sur un lien
        const menuLinks = mainNavigation.querySelectorAll('a');
        menuLinks.forEach(link => {
            link.addEventListener('click', function(e) {
                if (window.innerWidth <= 768) {
                    document.body.classList.remove('menu-open');
                }
            });
        });
    }

    if (header) {
        window.addEventListener('scroll', function() {
            const headerIsAbsolute = header.classList.contains('header-absolute');
            const currentScroll = window.pageYOffset;

            if (currentScroll > 100) {
                header.classList.add('header-scrolled');
                header.classList.add('kf-header-sticky');
                header.classList.add('sticky');
                if(headerIsAbsolute) {
                    header.classList.remove('header-absolute');
                }
            } else {
                header.classList.remove('header-scrolled');
                header.classList.remove('kf-header-sticky');
                header.classList.remove('sticky');
                if(headerIsAbsolute) {
                    header.classList.add('header-absolute');
                }
            }

            lastScroll = currentScroll;
        });
    }

    const menuItemsWithSubmenu = document.querySelectorAll('.menu-item-has-children');
    menuItemsWithSubmenu.forEach(item => {
        const link = item.querySelector('a');
        const submenu = item.querySelector('.sub-menu');

        if (window.innerWidth <= 768 && link && submenu) {
            link.addEventListener('click', function(e) {
                e.preventDefault();
                submenu.classList.toggle('active');
            });
        }
    });

    // Redimensionnement de la fenêtre
    window.addEventListener('resize', function() {
        if (window.innerWidth > 768 && mobileMenuToggle && mainNavigation) {
            mobileMenuToggle.classList.remove('active');
            mainNavigation.classList.remove('active');
            document.body.classList.remove('menu-open');
            
            // Réinitialiser les sous-menus
            const submenus = document.querySelectorAll('.sub-menu');
            submenus.forEach(submenu => {
                submenu.classList.remove('active');
            });
        }
    });
}); 